
function NotFound() {
  return (
  <div>
    <h1>Not found</h1>
        <p>Sorry, we were unable to find what you were looking for.</p>
  </div>
  )
}


export default NotFound;